// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts', {
        url: '/contacts',
        parent: 'main',
        abstract: true,
        templateUrl: "main/contacts/contacts.tpl.html",
        controller: "MainContactsController as vm"
    });
}

// @ngInject
function MainContactsController() {
    var vm = this;
}

angular.module('main.contacts', ['contacts.locations', 'contacts.users', 'contacts.companies', 'contacts.roles', 'contacts.bulkoperation'])
       .config(stateConfig)
       .controller('MainContactsController', MainContactsController);
